import React from 'react';
import '../pages/OurExpertise.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faBalanceScale,
  faUniversity,
  faLaptop,
  faHandshake,
  faGraduationCap,
} from '@fortawesome/free-solid-svg-icons';

const EXPERTISE_ITEMS = [
  {
    icon: faUsers,
    title: 'Mediation',
    description:
      'Our seasoned mediators create an inclusive environment where parties can openly communicate and collaboratively seek resolutions through voluntary dialogue.',
  },
  {
    icon: faBalanceScale,
    title: 'Arbitration',
    description:
      'Expert arbitrators deliver swift, binding decisions that meet the highest standards of legality, providing a streamlined alternative to traditional court proceedings.',
  },
  {
    icon: faUniversity,
    title: 'Institutional Arbitrations',
    description:
      'Formalized administration of arbitration by institutions according to dedicated rules and procedures, ensuring transparency and institutional support.',
  },
  {
    icon: faLaptop,
    title: 'Online Dispute Resolution',
    description:
      'Embracing the digital era, our ODR solutions provide the convenience of resolving disputes remotely, promoting accessibility and reducing barriers to justice.',
  },
  {
    icon: faHandshake,
    title: 'Negotiation Support',
    description:
      'Skilled negotiators craft strategies that balance assertiveness with compromise, advocating for favorable outcomes while prioritizing relationship preservation.',
  },
  {
    icon: faGraduationCap,
    title: 'Training and Workshops',
    description:
      'Educational programs empowering clients to proactively manage disputes through conflict resolution skills, fostering a culture of understanding.',
  },
];

function OurExpertise() {
  return (
    <Container fluid className="expertiseContainer">
      <Row className="justify-content-center">
        <Col md={12} className="text-center">
          <h2 className="expertiseHeading">Our Expertise</h2>
          <div className="expertiseUnderline"></div>
        </Col>
      </Row>

      <Row className="expertiseCards g-4">
        {EXPERTISE_ITEMS.map(({ icon, title, description }) => (
          <Col md={4} key={title}>
            <div className="expertiseCard">
              <div className="expertiseIconBox">
                <FontAwesomeIcon icon={icon} />
              </div>
              <h5 className="expertiseCardTitle">{title}</h5>
              <p className="expertiseCardText">{description}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default OurExpertise;
